export default function initOffresEmplois() {
    const resultsTable = document.querySelector('.results-table table');

    if (resultsTable) {
        const resultsTableBodyRows = resultsTable.querySelectorAll('tbody tr');

        resultsTableBodyRows.forEach((row) => {
            row.addEventListener('click', () => {
                const href = row.querySelector('a').getAttribute('href');

                // Go to the link
                window.location.href = href;
            });
        });
    }

    const dataFiltersBtns = document.querySelectorAll('[data-filters-btn]');

    if (dataFiltersBtns) {
        dataFiltersBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const target = btn.getAttribute('data-filters-btn');
                const targetEl = document.querySelector(`[data-filters="${target}"]`);

                if (targetEl) {
                    btn.classList.toggle('is-active');
                    targetEl.classList.toggle('is-active');
                }
            });
        });
    }

    const dataRemoveSecteurRromUrlBtns = document.querySelectorAll(
        '[data-remove-secteur-from-url]'
    );
    const dataRemoveTypeRromUrlBtns = document.querySelectorAll('[data-remove-type-from-url]');

    if (dataRemoveSecteurRromUrlBtns) {
        dataRemoveSecteurRromUrlBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const currentUrl = window.location.href;
                const secteurSlug = btn.getAttribute('data-remove-secteur-from-url');
                let newUrl = currentUrl.replace(`&secteur=${secteurSlug}`, '');
                newUrl = newUrl.replace(`?secteur=${secteurSlug}`, '');
                // Does newUrl contains any '?' caracter?
                if (newUrl.indexOf('?') !== -1) {
                    window.location.href = newUrl;
                } else {
                    // Replace first '&' caracter with '?'
                    newUrl = newUrl.replace('&', '?');
                    window.location.href = newUrl;
                }
            });
        });
    }

    if (dataRemoveTypeRromUrlBtns) {
        dataRemoveTypeRromUrlBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const currentUrl = window.location.href;
                const typeSlug = btn.getAttribute('data-remove-type-from-url');
                let newUrl = currentUrl.replace(`&type=${typeSlug}`, '');
                newUrl = newUrl.replace(`?type=${typeSlug}`, '');
                window.location.href = newUrl;
                // Does newUrl contains any '?' caracter?
                if (newUrl.indexOf('?') !== -1) {
                    window.location.href = newUrl;
                } else {
                    // Replace first '&' caracter with '?'
                    newUrl = newUrl.replace('&', '?');
                    window.location.href = newUrl;
                }
            });
        });
    }

    const dataLoadMoreItemsAttribute = '[data-load-more-items]';

    if (document.querySelector('.emplois-index-listing')) {
        document.querySelector('.emplois-index-listing').addEventListener('click', (e) => {
            if (e.target.closest(dataLoadMoreItemsAttribute)) {
                e.preventDefault();
                const target = e.target.closest(dataLoadMoreItemsAttribute);
                let loadMoreHref = target.getAttribute('href');
                // get urls params
                let urlParams = new URLSearchParams(window.location.search);
                loadMoreHref = loadMoreHref + `?${urlParams.toString()}`;

                target.classList.add('is-loading');
                target.setAttribute('aria-disabled', true);
                target.setAttribute('tabindex', -1);
                target.setAttribute('disabled', true);

                fetch(loadMoreHref)
                    .then((response) => response.text())
                    .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const newItems = doc.querySelector(
                            '.emplois-index-listing .left-listing table tbody'
                        ).innerHTML;
                        const newLoadMoreBtn = doc.querySelector(dataLoadMoreItemsAttribute);

                        document.querySelector(
                            '.emplois-index-listing .left-listing table tbody'
                        ).innerHTML += newItems;

                        if (newLoadMoreBtn) {
                            target.setAttribute('href', newLoadMoreBtn.getAttribute('href'));
                            target.classList.remove('is-loading');

                            target.removeAttribute('aria-disabled');
                            target.removeAttribute('tabindex');
                            target.removeAttribute('disabled');
                        } else {
                            target.remove();
                        }
                    });
            }
        });
    }

    const offreEmploisForm = document.querySelector('.offre-emplois-form');
    if (!offreEmploisForm) {
        return;
    }

    const fSecteurDactivite = document.querySelector('#f-secteurDactivite');

    fSecteurDactivite.addEventListener('change', (e) => {
        const target = e.target;
        const targetValue = target.value;

        const relatedSelect = document.querySelector('#show-' + targetValue);

        const allRelatedSelects = document.querySelectorAll('#autre div');
        allRelatedSelects.forEach((select) => {
            select.classList.remove('is-active');
            select.setAttribute('aria-hidden', true);
            select.setAttribute('tabindex', -1);

            if (select.querySelector('select')) {
                select.querySelector('select').removeAttribute('required');
                select.querySelector('select').setAttribute('name', '');
            }
        });

        if (targetValue && relatedSelect && relatedSelect.querySelectorAll('option').length >= 1) {
            document.querySelector('#autre').classList.add('is-active');
            document.querySelector('#autre').setAttribute('aria-hidden', false);
            document.querySelector('#autre').setAttribute('tabindex', 0);

            relatedSelect.classList.add('is-active');
            relatedSelect.setAttribute('aria-hidden', false);
            relatedSelect.setAttribute('tabindex', 0);

            relatedSelect.querySelector('select').setAttribute('required', true);
            relatedSelect
                .querySelector('select')
                .setAttribute('name', 'fields[secteurDactivite][]');
        } else {
            document.querySelector('#autre').classList.remove('is-active');
            document.querySelector('#autre').setAttribute('aria-hidden', true);
            document.querySelector('#autre').setAttribute('tabindex', -1);
        }
    });
}
